import React from 'react'
import { Cerberus } from 'component-library/compositions/Cerberus/Cerberus'
import { createRegisterableComposition } from 'common/routing/page-definition'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export interface CerberusRouteProps {
    verticalSpacing?: keyof ThemeMargins
    stretchColumns: boolean
    hasSeparators?: boolean
    hasBackgroundFill?: boolean
}

export const CerberusFourRegistration = createRegisterableComposition<
    'content1' | 'content2' | 'content3' | 'content4'
>()('cerberus-four', (contentAreas, props: CerberusRouteProps) => (
    <Cerberus
        {...props}
        content={[
            contentAreas.content1,
            contentAreas.content2,
            contentAreas.content3,
            contentAreas.content4,
        ]}
    />
))
